import { createResourceStore } from "@/lib/resource";
import type { User } from "./User";

export interface Employee {
  id: string;
  userid: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  role: string;
  hire_date: string;
  status: string;
  description: string;
  shopid: string;
  country: string;
  address: string;
  date_of_birth: string;
  national_id: string;
  employment_status: string;
  emergency_contact: string;
  education: string;
  salary: string;
  created_at: string;
  updated_at: string;
  user: User;
}

export const useEmployee = createResourceStore<Employee>("employees");
